import React from 'react';
import { Form, Input, Select } from 'formik-antd';

const NocDrivingLicense = (): React.ReactElement => {
  return (
    <>
      <h3>NOC - Driving License</h3>
      <Form.Item name={`drivingInstitureName`} label="Driving Institute Name">
        <Input name="drivingInstitureName" />
      </Form.Item>
      <Form.Item name={`emirate`} label="Emirate">
        <Select name={`emirate`}>
          <Select.Option value='Abu Dhabi'>Abu Dhabi</Select.Option>
          <Select.Option value='Ajman'>Ajman</Select.Option>
          <Select.Option value='Dubai'>Dubai</Select.Option>
          <Select.Option value='Fujairah'>Fujairah</Select.Option>
          <Select.Option value='Ras al-Khaimah'>Ras al-Khaimah</Select.Option>
          <Select.Option value='Sharjah'>Sharjah</Select.Option>
          <Select.Option value='Umm al-Quwain'>Umm al-Quwain</Select.Option>
        </Select>
      </Form.Item>
    </>
  );
};

export default NocDrivingLicense;
